import React from 'react';
import './Pwani.css';
import Pic from '../assets/pwani.png';
import PwaniMap from './PwaniMap';
import Kilifi from '../assets/kilifi.jpg';


function Pwani() {
  return (
    <div className='pwani'>
       <p className='venue1'>The 6th edition of the KIPPRA Annual Regional Conference will be held from 21st to 23rd of June at the Pwani University in Kilifi County.</p>
        <h1>PWANI UNIVERSITY</h1>
        <p className='venue2'>
        <span style={{fontWeight: "600"}}>Pwani University </span> is a public university  in Kenya. The university is located 60 km north of Mombasa City in Kilifi Town, Kilifi County. It is strategically positioned, close to the Kilifi Bay along the busy Mombasa-Malindi highway. Prior to the award of a Charter, the University was a Constituent College of Kenyatta University. The university was awarded charter on 31st January 2013 becoming a fully-fledged university.  
        </p>
        <img src={Pic} alt="Pwani University" className='pic' />
        <p className='venue3'>Main entrance to Pwani University</p>
      
        <div style={{marginTop: "30px"}}>
      <PwaniMap />
      </div>
      <div >
  </div>

      <div className='kilifi'>

        <h1>KILIFI COUNTY</h1>
        <img src={Kilifi} alt="Kilifi county" className='governor' style={{alignItems: "center"}} />
        <p className='venue3' style={{textAlign: "center"}}>Kilifi County</p>

        <p className='venue2'>
        Kilifi County is an ASAL county in Kenya located in the former Coast Province. The county is known for its beautiful beaches, vibrant culture, and historical sites, such as the Gede Ruins and the Mnarani Ruins.
        </p>

        <p className='venue2'>
        The Governor of Kilifi County is, H.E. Gideon Mung’aro, OGW while the Deputy Governor is Hon. Flora Mbetsa Chibule. Kilifi County’s main economic activities include fishing, agriculture, and tourism.
        </p>
      </div>
     
    </div>
  )
}

export default Pwani
